export default __webpack_public_path__ + "static/media/logofarmacias1.52939bf2.png";